const hotels = {
  accommodation: "Penginapan", // translated 
  hotel: "Hotel", // translated 
  hotels: "Hotel", // translated 
  back: "Kembali", // translated 
  rooms: "Bilik-bilik", // translated 
  viewPictures: "Lihat Gambar", // translated 
  showMore: "tunjukkan lebih banyak lagi", // translated 
  bookingInformation: "Maklumat Tempahan", // translated 
  cancellationPolicy: "Polisi Pembatalan", // translated 
  from: "Dari", // translated 
  to: "Προς την", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  free: "percuma", // translated 
  chargeableWithFeeOf: "dikenakan bayaran sebanyak", // translated 
  prebook: "Pra-tempah", // translated 
  guests: "Tetamu", // translated 
  payment: "Pembayaran", // translated 
  byClicking: "Dengan mengklik", // translated 
  next: "Seterusnya", // translated 
  youAreAgreeingToOur: "anda bersetuju dengan kami", // translated 
  termsAndConditions: "Terma dan Syarat", // translated 
  previous: "Sebelumnya", // translated 
  cancel: "Batal", // translated 
  mealPlan: "Pelan Makanan", // translated 
  roomType: "Jenis Bilik", // translated 
  description: "Penerangan", // translated 
  readLess: "Baca Kurang", // translated 
  readMore: "Baca Lagi", // translated 
  facilities: "Kemudahan", // translated 
  viewLess: "Lihat Kurang", // translated 
  viewMore: "Lihat Lagi", // translated 
  less: "kurang", // translated 
  more: "lebih banyak", // translated 
  notAvailable_short: "Tidak Ada", // translated 
  backToHotelList: "Kembali ke senarai hotel", // translated 
  viewOnMap: "Lihat di peta", // translated 
  sleeps: "Tidur", // translated 
  adults: "Dewasa", // translated 
  yearsOld: "tahun", // translated 
  type: "Jenis", // translated 
  bedding: "Peralatan tidur", // translated 
  selectRoom: "Pilih Bilik", // translated 
  selectRooms: "Pilih Bilik", // translated 
  city: "Bandar", // translated 
  checkIn: "Daftar Masuk", // translated 
  checkOut: "Daftar Keluar", // translated 
  date: "Tarikh", // translated 
  dates: "Tarikh", // translated 
  persons: "Orang", // translated 
  stillOnTrialQuestionToUpgrade:
    "Alamak! Nampaknya anda masih dalam keahlian percubaan. Anda perlu menjadi ahli yang disahkan untuk membuat tempahan. Adakah anda ingin menaik taraf sekarang?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "Alamak! Nampaknya anda belum melanggan lagi. Anda perlu menjadi ahli yang disahkan untuk membuat tempahan. Adakah anda ingin menaik taraf sekarang?", // translated 
  completeProfile: "Sila lengkapkan profil pengguna anda terlebih dahulu", // translated 
  upgrade: "Αναβαθμίζω", // translated 
  close: "Tutup", // translated 
  viewDetails: "Lihat Butiran", // translated 
  name: "Nama", // translated 
  rating: "Penilaian", // translated 
  budget: "Bajet", // translated 
  orderBy: "Pesan Mengikut", // translated 
  priceLowestFirst: "Harga (terendah dahulu)", // translated 
  priceHighestFirst: "Harga (tertinggi dahulu)", // translated 
  ratingLowestFirst: "Penilaian (terendah dahulu)", // translated 
  ratingHighestFirst: "Penilaian (tertinggi dahulu)", // translated 
  starRatingAndPrice: "Penarafan Bintang dan Harga", // translated 
  biggestSavingsFirst: "Penjimatan Terbesar Dahulukan", // translated 
  select: "Pilih", // translated 
  reset: "Tetapkan semula", // translated 
  apply: "Mohon", // translated 
  filterBy: "Tapis mengikut", // translated 
  myProfile: "Profil Saya", // translated 
  login: "Log masuk", // translated 
  roomOnly: "Bilik Sahaja", // translated 
  bedAndBreakfast: "Penginapan & Sarapan", // translated 
  halfBoard: "Separuh Makan", // translated 
  fullBoard: "Makan Penuh", // translated 
  allInclusive: "Semua Termasuk", // translated 
  filter: "Penapis", // translated 
  mapView: "Paparan Peta", // translated 
  results: "keputusan", // translated 
  listView: "Paparan Senarai", // translated 
  newSearch: "Carian Baharu", // translated 
  editSearch: "Edit Carian", // translated 
  all: "Semua", // translated 
  multiple: "Berbilang", // translated 
  editProfile: "Sunting Profil", // translated 
  backToHotelsList: "Kembali ke Senarai Hotel", // translated 
  roomName: "Nama Bilik", // translated 
  mealType: "Jenis Makanan", // translated 
  freeCancellation: "Pembatalan Percuma", // translated 
  yes: "Ya", // translated 
  no: "Οχι", // translated 
  filters: "Penapis", // translated 
  cancellationNonRefundable: "Pembatalan tidak boleh dikembalikan", // translated 
  hotelRating: "Penilaian Hotel", // translated 
  any: "Mana-mana", // translated 
  off: "Mati", // translated 
  performNewSearch: "Lakukan carian baharu", // translated 
};






export default hotels;
